import styled from "styled-components";

import { Button } from "@similarweb/ui-components";

export const StyledShowMoreButton = styled(Button)`
    max-height: 28px;

    & > div {
        font-size: 10px;
    }
`;
